"use strict";

angular.module("vendor")
.controller("CustomerFinancialController", function(
    $scope, $resource, gettextCatalog, common, FlashBag, appConfig, CustomerFinancialService,
    PartnershipStatusFilterService, PartnershipTagService, SalesRepStatusFilterService, FinancialStatusFilterService
) {
    $scope.service = CustomerFinancialService;
    $scope.statusFilterService = PartnershipStatusFilterService;
    $scope.tagFilterService = PartnershipTagService;
    $scope.salesRepFilterService = SalesRepStatusFilterService;
    $scope.financialFilterService = FinancialStatusFilterService;

    this.exportData = function() {
        if ($scope.isExporting) {
            return;
        }

        $scope.isExporting = true;
        $resource(appConfig.API_SERVER + "/auth/vendor/partnerships/financial/export/").get().$promise
        .then(function(data) {
            var file_data = data.file_data;
            if (file_data) {
                common.downloadExcelFile(file_data, data.file_name);
            }
            else {
                FlashBag.preformattedError(gettextCatalog.getString("There was an error while generating the file. Please try again."));
            }
        }).finally(function() {
            $scope.isExporting = false;
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/customer/customer-financial.controller.js
// module id = 995
// module chunks = 0